import React from 'react'
import PropTypes from 'prop-types'

import AuthorizePlatformDetails from '../../SocialAuthorize/AuthorizePlatformDetails'
import PageSectionHeader from '../../../features/components/PageSectionHeader'
import SocialPostsContent from './SocialPostsContent'

import usePlatformConnected from '../../../features/hooks/usePlatformConnected'

import { FACEBOOK_PLATFORM } from '../../../constants/selectLists/platformList'

const SocialPosts = ({ rightId }) => {
  const isFacebookPlatformConnected = usePlatformConnected(FACEBOOK_PLATFORM)

  // todo decide how to handle facebook together with twitter when adding the last one
  if (!isFacebookPlatformConnected) {
    return (
      <>
        <PageSectionHeader title="Social Posts - Facebook" />
        <AuthorizePlatformDetails
          selectedPlatform={FACEBOOK_PLATFORM}
          explanationText="Please authenticate with Facebook to retrieve the list of social posts."
        />
      </>
    )
  }

  return <SocialPostsContent rightId={rightId} />
}

SocialPosts.propTypes = {
  rightId: PropTypes.string.isRequired
}

export default SocialPosts
